import { useState } from 'react';
import { useEditorStore } from '../store/editor-store';
import { EDITOR_FONTS } from '../lib/text-ui';

/** First step: type text + pick typography (La Tostadora “Añadir texto”). */
export function AddTextPanel() {
  const addText = useEditorStore((s) => s.addText);
  const setPanel = useEditorStore((s) => s.setPanel);
  const setTool = useEditorStore((s) => s.setTool);
  const [draft, setDraft] = useState('');

  function confirm(fontFamily: string) {
    const content = draft.trim() || 'Texto';
    addText({ content, fontFamily });
    setTool('select');
  }

  return (
    <div className="ox-side-panel ox-add-text-panel">
      <div className="ox-panel-head">
        <h3>Añadir texto</h3>
        <button
          type="button"
          className="ox-panel-close"
          aria-label="Cerrar"
          onClick={() => {
            setPanel('none');
            setTool('select');
          }}
        >
          ✕
        </button>
      </div>
      <label>
        <textarea
          maxLength={200}
          value={draft}
          placeholder="Escribe tu texto"
          onChange={(e) => setDraft(e.target.value)}
          autoFocus
        />
        <span className="ox-counter">
          {draft.length} / 200
        </span>
      </label>
      <p className="ox-font-hint">Elige una tipografía</p>
      <ul className="ox-font-list">
        {EDITOR_FONTS.map((f) => (
          <li key={f.label}>
            <button type="button" className="ox-font-item" onClick={() => confirm(f.family)}>
              <span className="ox-font-preview" style={{ fontFamily: f.family }}>
                {draft.trim() || 'Aa'}
              </span>
              <span className="ox-font-name">{f.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
